module.exports = __webpack_public_path__ + "static/media/weather.87ec406f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mediaDnd/weather.svg
// module id = 1415
// module chunks = 1